module.exports = "<section>\n    payment schedule works\n</section>\n\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/invoice-update/invoice-payment-schedule/invoice-payment-schedule.html
// module id = ./web/modern/components/invoices/invoice-update/invoice-payment-schedule/invoice-payment-schedule.html
// module chunks = 0